import DataService from '@/core/base/service/data.service';
import {ChartJsHeader, IReport, Report} from "@/shared/model/report.model";
import axios from "axios";
import {PaginationQuery} from "@/shared/sort/pagination-query.interface";
import buildPaginationQueryOpts from "@/shared/sort/sorts";
import {ReportLayout} from "@/shared/model/report-layout.model";
import {ChartConfiguration, ChartData, ChartTypeRegistry} from "chart.js";
import {Ref} from "@vue/composition-api";

export default class ReportService extends DataService<Report> {
    baseApiUrl = 'api/report';

    public fetchLayout(): Promise<ReportLayout[]> {
        return new Promise<ReportLayout[]>((resolve, reject) => {
            axios
                .get(this.baseApiUrl)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public find(id: number, paginationQuery?: PaginationQuery): Promise<Report> {
        return new Promise<Report>((resolve, reject) => {
            axios
                .get(`${this.baseApiUrl}/${id}?${buildPaginationQueryOpts(paginationQuery)}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public getChartJsConfig(fullReport: IReport, headers: Ref<string[]>): ChartConfiguration {

        const labels: ChartJsHeader[] = [];
        fullReport.series.forEach(series => series.data
            .forEach(entry => {
                if (!labels.find(e => e.label === entry[0])) {
                    labels.push({
                        label: entry[0],
                        order: entry[1] + "",
                    });
                }
            }));

        labels.sort((a, b) => a.order.localeCompare(b.order));
        headers.value = labels.map(label => label.label);

        fullReport.series = fullReport.series.map(series => {
            series.data
                .sort((a, b) => a[1].localeCompare(b[1]));
            return series;
        });

        const data: ChartData = {
            labels: headers.value,
            datasets: fullReport.series.map(series => {
                return {
                    label: series.name,
                    data: series.data.map(entry => entry[2]),
                    borderColor: series.color,
                    backgroundColor: series.color,
                };
            }),
        };

        return {
            type: fullReport.type.toLowerCase() as keyof ChartTypeRegistry,
            data,
        };
    }
}
